import { ChangeDetectorRef, Component } from '@angular/core';
import { CacheService } from '@shared/services/cache.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlossaryService } from '@shared/services/glossary.service';
import { ItemsDirective } from '@shared/directives/items.directive';
import { IGlossary, ITeaser } from '@shared/interfaces';

@Component({
    selector: 'app-glossary',
    templateUrl: './glossary.component.html',
    styleUrls: ['./glossary.component.scss'],
    standalone: false
})
export class GlossaryComponent extends ItemsDirective {
    public teaserItems: { teaser: ITeaser; item: IGlossary }[];

    public async loadData() {
        this.items = this.cache.glossary
            ? this.cache.glossary
            : this.cache.homeItems
              ? this.cache.homeItems.glossary
              : [];
        super.loadData();
        this.items = this.cache.glossary = await this.glossaryService.getAllItems();
        super.loadData();
    }

    constructor(
        changeDetection: ChangeDetectorRef,
        cache: CacheService,
        router: Router,
        translateService: TranslateService,
        private glossaryService: GlossaryService
    ) {
        super(changeDetection, cache, router, translateService);
    }
}
